<div class="header">
  <div class="header__logo" (click)="onWeb()">
    <img src="/images/aradalogo2.png" alt="aradalogo" class="header__logo" />
  </div>

  <p class="header__slogan">Arada Home Away From Home</p>
</div>
